import React from 'react';
import { useParams } from 'react-router-dom';
import { fetchCandidateSkills } from '../../../api/candidate';
import useFetch from '../../../hooks/useFetch';
import Section from '../../common/section';
import Wrapper from '../wrapper';

const View = () => {
  const { hash } = useParams();
  const { result: skillsXPeriod } = useFetch(fetchCandidateSkills, hash, [
    hash,
  ]);

  if (!Array.isArray(skillsXPeriod) || !skillsXPeriod.length) return null;

  return (
    <Section title="Skills">
      {skillsXPeriod.map(({ skills, ...period }) => (
        <Wrapper key={period.hash} period={period} skills={skills} />
      ))}
    </Section>
  );
};

export default View;
